<template>
  <div>
    <div v-if="currentStep === 1">
      <p class="block margin-l-bottom">
        {{ translateUcFirst("core.resetPassword.resetPasswordExplain") }}
      </p>
      <base-form
        ref="resetPassword1Form"
        v-model="resetPassword1FormData"
        method="post"
        action="/token/otp"
        :config="resetPassword1FormConfig"
        @form:submit-success="handleStep1Success">
      </base-form>
    </div>
    <div v-if="currentStep === 2">
      <icon-text
        class="c-lead-2 cursor-pointer margin-xl-bottom"
        icon="chevron-inline-start"
        @click="currentStep = 1"
        >{{ translateUcFirst("core.resetPassword.resetPasswordBackToStep1") }}</icon-text
      >
      <p class="block margin-l-bottom">
        {{ translateUcFirst("core.resetPassword.resetPasswordExplainStep2", {medium: translate(`core.resetPassword.medium.${resetPassword1FormData.medium}`)}) }}
      </p>
      <base-form
        ref="resetPassword2Form"
        v-model="resetPassword2FormData"
        method="post"
        action="/user/reset-password"
        :config="resetPassword2FormConfig"
        @form:submit-success="handleStep2Form">
      </base-form>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";

export default {
  emits: ["finished"],
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      identifierFields: {
        email: {
          name: "identifier",
          icon: "mail",
          type: "email",
          label: "core.resetPassword.identifierFieldEmailLabel",
          placeholder: "core.resetPassword.identifierFieldEmailPlaceholder",
          validation: {
            required: {},
            email: {},
          },
        },
        whatsapp: {
          name: "identifier",
          icon: "iphone",
          type: "i18nPhoneNumber",
          label: "core.resetPassword.identifierFieldWhatsappLabel",
          placeholder: "core.resetPassword.identifierFieldWhatsappPlaceholder",
          validation: {
            required: {},
            i18nPhoneNumberObject: {},
          },
        },
        sms: {
          name: "identifier",
          icon: "iphone",
          type: "i18nPhoneNumber",
          label: "core.resetPassword.identifierFieldSmsLabel",
          placeholder: "core.resetPassword.identifierFieldSmsPlaceholder",
          validation: {
            required: {},
            i18nPhoneNumberObject: {},
          },
        },
      },
      currentStep: 1,
      resetPassword1FormData: {
        identifier: "",
        medium: "email",
        password: "",
        password2: "",
      },
      resetPassword2FormData: {
        password: "",
        otp: "",
        verification: {},
      },
      resetPassword1FormConfig: {
        fields: {
          medium: {
            name: "medium",
            label: "core.resetPassword.mediumLabel",
            legend: "core.resetPassword.mediumLegend",
            type: "hidden",
          //  type: "select",
            multiple: false,
            list: [
              {value: "email", label: "core.resetPassword.medium.email"},
              {value: "sms", label: "core.resetPassword.medium.sms"},
              {value: "whatsapp", label: "core.resetPassword.medium.whatsapp"},
            ]
          },
          identifier: {
            name: "identifier",
            icon: "mail",
            type: "email",
            label: "core.resetPassword.resetPasswordEmailLabel",
            placeholder: "core.resetPassword.resetPasswordEmailPlaceholder",
            validation: {
              required: {},
              email: {},
            },
          },
          password: {
            icon: "lock",
            name: "password",
            type: "password",
            label: "core.resetPassword.resetPasswordPasswordLabel",
            validation: {
              required: {},
            },
          },
          password2: {
            icon: "lock",
            name: "password2",
            type: "password",
            label: "core.resetPassword.resetPasswordPassword2Label",
            validation: {
              required: {},
            },
          },
        },
        buttons: {
          submit: {
            type: "submit",
            text: "core.resetPassword.resetPasswordStep1Cta",
          },
        },
      },
      resetPassword2FormConfig: {
        formHandling: {},
        fields: {
          otp: {
            icon: "lock",
            name: "otp",
            type: "text",
            autocomplete: "false",
            label: "core.resetPassword.resetPasswordOtpLabel",
            validation: {
              required: {},
            },
          },
          password: {
            name: "password",
            type: "hidden",
            disabled: true,
          },
          medium: {
            name: "medium",
            type: "hidden",
            disabled: true,
          },
          verification: {
            icon: "lock",
            name: "verification",
            type: "hidden",
            disabled: true,
          },
        },
        buttons: {
          submit: {
            type: "submit",
            text: "core.resetPassword.resetPasswordStep2Cta",
          },
        },
      },
    };
  },
  watch: {
    "resetPassword1FormData.identifier": {
      handler(newVal) {
        this.resetPassword2FormData.identifier = newVal;
      },
      immediate: true
    },
    "resetPassword1FormData.password": {
      handler(newVal) {
        this.resetPassword2FormData.password = newVal;
      },
      immediate: true,
    },
    "resetPassword1FormData.medium": {
      handler(newVal) {
        console.log("new medium", newVal);

        // set medium to step 2
        this.resetPassword2FormData.medium = newVal;

        // clear the identifier value
        this.resetPassword1FormData.identifier = null;

        // change form field
        this.resetPassword1FormConfig.fields.identifier = this.identifierFields[newVal];
      },
      immediate: true,
    }
  },
  methods: {
    handleStep1Success(event) {
      this.resetPassword2FormData.verification = event.result.data.verification;
      this.currentStep = 2;
      this.$s.ui.notification(
        "core.resetPassword.resetPasswordSuccessStep1Notification",
        "success"
      );
    },
    reset() {
      this.currentStep = 1;

      this.resetPassword1FormData = {
        medium: "email",
        identifier: "",
        password2: "",
        password: "",
        otp: "",
      };
      this.resetPassword2FormData = {
        medium: "email",
        identifier: "",
        password: "",
        otp: "",
        verification: {}
      };
    },
    async handleStep2Form(event) {
      this.$s.ui.notification("core.resetPassword.resetPasswordSuccessNotification");
      this.$emit("finished", {
        ...event.result.data,
        password: this.resetPassword2FormData.password,
      });

      this.reset();
    },
  },
};
</script>

<style scoped lang="scss"></style>
